/* eslint-disable max-classes-per-file */
import React, { useEffect, useState } from 'react';
export class Column {
  name: string;
  sortBy?: string;
  colSpan?: number;
  template: ( col: Column ) => React.ReactElement;
  useAsFilter?: boolean;

  constructor( name: string, sortBy?: string, colSpan: number = 1, template?: ( col: Column ) => React.ReactElement, useAsFilter = true ) {
    this.name = name;
    this.sortBy = sortBy;
    this.colSpan = colSpan;
    this.useAsFilter = useAsFilter;

    if ( template == null )
    {template = ( col: Column ) => {
      return <p>{col.name}</p>;
    };}
    this.template = template;
  }

  static fromArrayString( list: string[] ): Column[] {
    const res: Column[] = [];
    list.map( str => {return res.push( new Column( str ) );} );
    return [ ...res ];
  }
}

export interface RowObject {
  id: string;
  name: string;
  icon?: string;
  isDeletable?: boolean;
}

export class Row {
  _object: RowObject;
  template: ( rowElement: string, object: RowObject, index?: number, col?: Column ) => React.ReactElement;

  constructor( object: RowObject, template?: ( rowElement: string, obj: RowObject, index?: number, col?: Column ) => React.ReactElement ) {
    this._object = object;

    if ( template == null ) {
      const tmpTemplate = ( rowElement: string ): React.ReactElement => {
        if ( typeof rowElement === 'object' ) {
          return <p>{rowElement}</p>;
        }
        return <p>{rowElement}</p>;
      };
      this.template = tmpTemplate;
    }
    else {
      this.template = template;
    }
  }

  static fromArrayObject( list: RowObject[] ): Row[] {
    const res: Row[] = [];
    list.map( object => {return res.push( new Row( object ) );} );
    return [ ...res ];
  }
}

interface TableSortableProps {
    title?: string;
    buttonTitle?: string;
    cols: Column[];
    rows: Row[];
    addButtonHandle?: () => void
    update?: unknown;
    updates?: unknown[];
    handleFilter?: ( filters: { id: string, name: string }[], input: string, rows: Row[] ) => Row[]
    handleSort?: ( order: 'none' | 'ascending' | 'descending', sortBy: string, rows: Row[] ) => Row[]
    filter?: boolean
    sortSelect?: boolean
}

const TableSortable = ( { title, buttonTitle, cols = [], rows = [], addButtonHandle, update, updates = [], handleSort }: TableSortableProps ) => {
  const columns = cols;
  const [ sortedRows, setSortedRows ] = useState( rows );

  const [ order, setOrder ] = useState<'none' | 'ascending' | 'descending'>( 'none' );
  const [ sortBy, setSortBy ] = useState( 'name' );

  const nbCols = columns.reduce( ( a, b ) => {return a + ( b.colSpan ? b.colSpan : 1 );}, 0 );
  const style = { gridTemplateColumns: `repeat(${nbCols}, minmax(0, 1fr))` };
  const border = ' divide-x divide-gray-300';

  useEffect( () => {
    setSortedRows(
      defaultHandleSort( order, sortBy, [ ...rows ] )
    );
  }, [ update, ...updates ] );


  useEffect( () => {
    setSortedRows( defaultHandleSort( order, sortBy, [ ...sortedRows ] ) );
  }, [ order, sortBy ] );


  function defaultHandleSort( _order: 'none' | 'ascending' | 'descending', _sortBy: string, _rows: Row[] ) {
    if ( handleSort != null ) {
      return handleSort( _order, _sortBy, [ ..._rows ] );
    }

    if ( _order === 'none' || !_sortBy ) {
      return [ ..._rows ];
    }

    const newRows = [ ..._rows ];
    newRows.sort( ( a, b ) => {
      const aValue = ( a._object && _sortBy in a._object ) ? ( a._object as RowObject )[ _sortBy as keyof RowObject ] ?? '' : '';
      const bValue = ( b._object && _sortBy in b._object ) ? ( b._object as RowObject )[ _sortBy as keyof RowObject ] ?? '' : '';
      if ( typeof aValue === 'string' && typeof bValue === 'string' ) {
        if ( aValue < bValue ) { return _order === 'ascending' ? -1 : 1; }
        if ( aValue > bValue ) { return _order === 'ascending' ? 1 : -1; }
        return 0;
      }
      return 0;
    } );
    return newRows;
  }

  function handleColumnClick( col: Column ) {
    if ( col.sortBy !== sortBy )
    {setOrder( 'ascending' );}

    else if ( order === 'ascending' || order === 'none' )
    {setOrder( 'descending' );}
    else {
      setOrder( 'ascending' );
    }
    setSortBy( col.sortBy ? col.sortBy : '' );
  }

  function outlined( col: Column ): string {
    let str = ' border-l border-gray-200';

    if ( sortBy === col.sortBy && order != 'none' )
    {str += ' bg-[#e6f0ff]';}

    return str;
  }


  return (
    <div className='w-full h-fit'>
      <div className={'mx-2 my-4 relative'}>
        <div className='w-full'>
          <div className={'flex right-0 place-content-end border border-slate-100 '}>
            {( title ) && ( <p className='w-full text-center pt-2 font-medium text-md text-gray-800 text-nowrap'> { title } </p> )}
            {addButtonHandle != null &&
                <button
                  type='button'
                  onClick={addButtonHandle}
                  className='form-button-validate w-fit h-fit m-1 right-0 z-10'
                  id={ `${buttonTitle}_tab_add_button` }
                >
                  <svg fill='#fff' width={15} height={15} viewBox='0 0 45.5 45.5' className='mr-2'>
                    <path d='M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141 c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27 c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435 c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z'></path>
                  </svg>
                  <label>{ buttonTitle ?? '' }</label>
                </button>
            }
          </div>

          <div className={'overflow-x-auto'}>
            <div className='w-max-full min-w-full'>
              {/* Sticky header and button */}
              <div style={{ position: 'sticky', top: 0, zIndex: 20, background: 'white' }}>
                <div className={'grid'} style={style}>
                  {columns.map( ( col, index ) => {
                    return <button
                      type='button'
                      onClick={() => {return handleColumnClick( col );}}
                      className={'hover:bg-slate-50 text-gray-600 font-medium relative ' + outlined( col )}
                      style={{ gridColumn: `span ${( col.colSpan ? col.colSpan : 1 )}` }}
                      key={'col_button_' + col.name?.toString() + '_' + index}
                    >
                      {( sortBy === col.sortBy && order != 'none' ) &&
                          <div className='absolute h-[90%] max-h-6 m-px top-0 right-0 rounded border border-gray-300 bg-blue-50/80 z-10'>
                            {order === 'ascending' ?
                              <svg viewBox='0 0 24 24' className='w-full h-full' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                <path d='M8.78 4.47C8.71 4.4 8.63 4.35 8.54 4.31C8.36 4.23 8.15 4.23 7.97 4.31C7.88 4.35 7.8 4.4 7.73 4.47L5.23 6.97C4.94 7.26 4.94 7.74 5.23 8.03C5.52 8.32 6 8.32 6.29 8.03L7.51 6.81V19C7.51 19.41 7.85 19.75 8.26 19.75C8.67 19.75 9.01 19.41 9.01 19V6.81L10.23 8.03C10.38 8.18 10.57 8.25 10.76 8.25C10.95 8.25 11.14 8.18 11.29 8.03C11.58 7.74 11.58 7.26 11.29 6.97L8.79 4.47H8.78Z' fill='#000000'></path>
                                <path d='M18.96 18.25L17.25 13.46C17.08 13.03 16.69 12.75 16.25 12.75C15.81 12.75 15.42 13.03 15.25 13.48L13.55 18.25C13.41 18.64 13.61 19.07 14 19.21C14.39 19.35 14.82 19.15 14.96 18.76L15.24 17.98H17.27L17.55 18.76C17.66 19.07 17.95 19.26 18.26 19.26C18.34 19.26 18.43 19.25 18.51 19.22C18.9 19.08 19.1 18.65 18.96 18.26V18.25ZM15.77 16.48L16.25 15.14L16.73 16.48H15.77Z' fill='#000000'></path>
                                <path d='M13.83 10.54C14.02 10.98 14.42 11.25 14.88 11.25H18.01C18.42 11.25 18.76 10.91 18.76 10.5C18.76 10.09 18.42 9.75001 18.01 9.75001H15.62L18.44 6.82001C18.78 6.46001 18.88 5.93001 18.68 5.47001C18.49 5.03001 18.09 4.76001 17.63 4.76001H14.52C14.11 4.76001 13.77 5.10001 13.77 5.51001C13.77 5.92001 14.11 6.26001 14.52 6.26001H16.91L14.08 9.21001C13.74 9.57001 13.65 10.09 13.84 10.55L13.83 10.54Z' fill='#000000'></path>
                              </svg>
                              :
                              <svg viewBox='0 0 24 24' className='w-full h-full' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                <path d='M10.22 15.97L9 17.19V5C9 4.59 8.66 4.25 8.25 4.25C7.84 4.25 7.5 4.59 7.5 5V17.19L6.28 15.97C5.99 15.68 5.51 15.68 5.22 15.97C4.93 16.26 4.93 16.74 5.22 17.03L7.72 19.53C7.79 19.6 7.87 19.65 7.96 19.69C8.05 19.73 8.15 19.75 8.25 19.75C8.35 19.75 8.44 19.73 8.54 19.69C8.63 19.65 8.71 19.6 8.78 19.53L11.28 17.03C11.57 16.74 11.57 16.26 11.28 15.97C10.99 15.68 10.51 15.68 10.22 15.97Z' fill='#000000'></path>
                                <path d='M18.96 18.25L17.25 13.46C17.08 13.03 16.69 12.75 16.25 12.75C15.81 12.75 15.42 13.03 15.25 13.48L13.55 18.25C13.41 18.64 13.61 19.07 14 19.21C14.39 19.35 14.82 19.15 14.96 18.76L15.24 17.98H17.27L17.55 18.76C17.66 19.07 17.95 19.26 18.26 19.26C18.34 19.26 18.43 19.25 18.51 19.22C18.9 19.08 19.1 18.65 18.96 18.26V18.25ZM15.77 16.48L16.25 15.14L16.73 16.48H15.77Z' fill='#000000'></path>
                                <path d='M13.83 10.54C14.02 10.98 14.42 11.25 14.88 11.25H18.01C18.42 11.25 18.76 10.91 18.76 10.5C18.76 10.09 18.42 9.75001 18.01 9.75001H15.62L18.44 6.82001C18.78 6.46001 18.88 5.93001 18.68 5.47001C18.49 5.03001 18.09 4.76001 17.63 4.76001H14.52C14.11 4.76001 13.77 5.10001 13.77 5.51001C13.77 5.92001 14.11 6.26001 14.52 6.26001H16.91L14.08 9.21001C13.74 9.57001 13.65 10.09 13.84 10.55L13.83 10.54Z' fill='#000000'></path>
                              </svg>
                            }
                          </div>
                      }
                      {col.template( col )}
                    </button>;
                  } )}
                </div>
              </div>

              {/* Table rows avec scroll interne */}
              <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {sortedRows.map( ( row, index ) => {
                  return <div className={'grid odd:bg-slate-200 even:bg-slate-100 ' + border} key={`${title}_rows_${index}`} style={style}>
                    <>
                      {
                        columns.map( ( col, _index ) => {
                          const value: string = ( row._object as never )[ col.name ] as string;
                          return (
                            <div
                              style={{ gridColumn: `span ${( columns[ _index ]?.colSpan ?? 1 )}` }}
                              key={`${title}_rows_${index}_row_case_${value}_${_index}`}
                              className='pl-2 text-gray-800 font-medium'
                            >
                              {row.template( value, row._object, _index, columns[ _index ] )}
                            </div>
                          );
                        } )
                      }
                    </>
                  </div>;
                } )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TableSortable;